const Cookies = require('js-cookie');

function init() {
    const promo = document.querySelector('.backstage-promo');

    if (!promo) {
        return false;
    }

    const closePromos = document.querySelector('.backstage-promo__close');
    const key = promo.getAttribute('id');
    const offset = 50;

    let viewed = parseInt(Cookies.get(key), 10) || 0;

    window.onscroll = function () {
        if (viewed) {
            return false;
        }

        const boundingRect = promo.getBoundingClientRect();
        const innerHeight = window.innerHeight - offset;

        if ((boundingRect.top <= innerHeight && boundingRect.top > offset) || (boundingRect.bottom <= innerHeight && boundingRect.bottom > offset)) {
            promo.classList.add('visible');
        } else {
            promo.classList.remove('visible');
        }
    };

    closePromos.onclick = function() {
        promo.classList.remove('visible');

        Cookies.set(key, 1, {
            path: '/',
            expires: 365
        });

        viewed = true;
    }
}

module.exports = {
    init
}
